import React from "react"
import { Box, Grid, Typography, Stack } from "@mui/material"
import { AuthorBySlug } from "@talentinc/gatsby-theme-ecom/types/blog/author"
import Section from "@talentinc/gatsby-theme-ecom/components/Section/Section"

interface AuthorPageProps {
  authorBySlug?: AuthorBySlug | null
}

export default function AuthorHero({ authorBySlug }: AuthorPageProps) {
  const { classes } = useStyles()

  return (
    <Box
      sx={{
        bgcolor: "#f6f7fa",
      }}
    >
      <Section>
        <Grid container>
          <Grid item lg={6} md={8} xs={12}>
            <Box className={classes.card}>
              <Stack direction="row" gap={2} alignItems={"center"}>
                <img src={authorBySlug?.authorImage?.file?.url ?? ""} className={classes.userImg} />
                <Typography variant="h1" className={classes.mainTitle}>
                  {authorBySlug?.authorName ?? ""}
                </Typography>
              </Stack>
              <Typography>
                {authorBySlug?.authorDescription &&
                  documentToReactComponents(JSON.parse(authorBySlug?.authorDescription?.raw ?? ""), {
                    renderNode: {
                      [BLOCKS.PARAGRAPH]: (node, children) => {
                        return <Typography className={classes.authorDescription}>{children}</Typography>
                      },
                      [INLINES.HYPERLINK]: (node, children) => {
                        const { uri } = node.data
                        return (
                          <Link className={classes.articleLinks} to={uri}>
                            {children}
                          </Link>
                        )
                      },
                    },
                  })}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Section>
    </Box>
  )
}

import { makeStyles } from "tss-react/mui"
import { Theme } from "@mui/material"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { BLOCKS, INLINES } from "@contentful/rich-text-types"
import { Link } from "gatsby"

export const useStyles = makeStyles()((theme: Theme) => {
  return {
    card: {
      display: "flex",
      flexDirection: "column",
      gap: "15px",
    },
    mainTitle: {
      fontFamily: "Tex Gyre",
      fontSize:"44px !important",
      color: "#0da1ec",
      [theme.breakpoints.down('md')]: {
        fontSize:"35px !important",
      },
      [theme.breakpoints.down('mobile')]: {
        fontSize:"30px !important",
      },
    },
    userImg: {
      width: "66px",
      height: "66px",
      borderRadius: "50%",
      border: "3px solid #0da1ec",
    },
    authorDescription: {
      fontSize: "17px !important",
      fontFamily: "proxima-nova !important",
      fontWeight: 400,
      lineHeight: "30px !important",
      [theme.breakpoints.down("lg")]: {
        fontSize: "17px !important",
        lineHeight: "26px !important",
      },
      [theme.breakpoints.down("md")]: {
        lineHeight: "26px !important",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "17px !important",
        lineHeight: "25px !important",
      },
    },
    articleLinks: {
      color: "#0DA1EC",
    },
  }
})
